var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "851b914a6ba1c8790c72e9d2f4b6b8bc9d501ab6"
};